// extracted by mini-css-extract-plugin
export default {"slash_header":"SlashHeader_slash_header__02IDP"};